/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useState } from "react";
import classes from "./TooltipContainer.module.scss";
import SystemContext from "../../../context/SystemContext";
import tourIconOne from "../../../assets/images/onboarding/tour_icon_one.svg";
import tourIconTwo from "./../../../assets/images/onboarding/tour_icon_two.svg";
import tourIconThree from "./../../../assets/images/onboarding/tour_icon_three.svg";
import tourIconFour from "./../../../assets/images/onboarding/tour_icon_four.svg";
import tourIconFive from "./../../../assets/images/onboarding/tour_icon_five.svg";
import tourIconSix from "./../../../assets/images/onboarding/tour_icon_six.svg";
import tourIconSeven from "./../../../assets/images/onboarding/tour_icon_seven.svg";
import tourIconStore from "./../../../assets/images/onboarding/tour_icon_store.svg";
import ReactJoyride from "react-joyride";
import ModalOnboardingStart from "../ModalOnboardingStart/ModalOnboardingStart";
import STATUS from "react-joyride";
import ModalOnboardingFinish from "../ModalOnboardingFinish/ModalOnboardingFinish";
import { useSelector } from "react-redux";

const TooltipContainer = ({}) => {
  const { configs } = useSelector((state) => state.configs);

  const [configtest, setconfigtest] = useState(null);

  useEffect(() => {
    setconfigtest(configtest);
  }, [configs]);


  const { openModalStart, setOpenModalStart } = useContext(SystemContext);
  const { session } = useSelector((state) => state.session);
  const [widthButton, setWidthButton] = useState("");
  const [heightButton, setHeightButton] = useState("");
  const [stepsFlow, setStepsFlow] = useState("");

  const [openModalFinish, setOpenModalFinish] = useState(false);
  const [steps, setSteps] = useState();
  const [run, setRun] = useState(false);

  const handleJoyrideCallback = (data) => {
    const { status } = data;
    if ([STATUS.FINISHED, STATUS.SKIPPED].includes(status)) {
      setRun(false);
    }
    if (status === "finished") {
      setOpenModalFinish(true);
    }
  };

  useEffect(() => {
    function obterLarguraDaTela() {
      const larguraTela =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;

      setWidthButton(larguraTela);
    }
    function obterAlturaDaTela() {
      const larguraTela =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight;

      setHeightButton(larguraTela);
    }

    window.addEventListener("resize", obterLarguraDaTela);
    window.addEventListener("resize", obterAlturaDaTela);

    obterLarguraDaTela();
    obterAlturaDaTela();
  }, []);

  useEffect(() => {
    if (session && session.my_user.typeUser.includes("patient")) {
      setStepsFlow([
        {
          title: "Escolha o jogo",
          description: "Encontre os jogos e áudios do Afinando por aqui!",
          target: ".activities",
          progress: "1/6",
          image: tourIconOne,
          placementDesk: "right",
          placementMob: "top",
        },
        {
          title: "Acompanhe suas conquistas",
          description:
            "Explore suas medalhas e fique de olho em suas metas!",
          target: ".conquest",
          progress: "2/6",
          image: tourIconTwo,
          placementDesk: "right",
          placementMob: "top",
        },
        {
          title: "Troca de itens",
          description:
            "Ganhou cristais ao bater suas metas? Troque por itens exclusivos da coleção do Afinando!",
          target: ".store",
          progress: "3/6",
          image: tourIconStore,
          placementDesk: "right",
          placementMob: "top",
        },
        {
          title: "Veja seu progresso",
          description:
            "Aqui você poderá acompanhar as pontuações e estatísticas de todas as jogadas feitas por você ou seus convidados",
          target: ".progress",
          progress: "4/6",
          image: tourIconThree,
          placementDesk: "right",
          placementMob: "top",
        },
        {
          title: "Planos do Afinando",
          description: "Confira os planos e pacotes adicionais da plataforma!",
          target: ".buy",
          progress: "5/6",
          image: tourIconFour,
          placementDesk: "right",
          placementMob: "top",
        },
   /*      {
          title: "Seu plano atual",
          description:
            "Confira qual é o seu plano atual e fique atento à data de renovação ou vencimento.",
          target: ".plans",
          progress: "6/7",
          image: tourIconSix,
          placementDesk: "bottom",
          placementMob: "top",
        }, */
        {
          title: "Menu de opções",
          description:
            "Convide usuários, resgate código de convite ou gerencie seus usuários por aqui",
          target: ".menu",
          progress: "6/6",
          image: tourIconSeven,
          placementDesk: "bottom",
          placementMob: "top",
        },
      ]);
    } else {
      setStepsFlow([
        {
          title: "Escolha o jogo",
          description: "Encontre os jogos e áudios do Afinando por aqui!",
          target: ".activities",
          progress: "1/7",
          image: tourIconOne,
          placementDesk: "right",
          placementMob: "top",
        },
        {
          title: "Acompanhe suas conquistas",
          description:
            "Explore suas medalhas e fique de olho em suas metas!",
          target: ".conquest",
          progress: "2/7",
          image: tourIconTwo,
          placementDesk: "right",
          placementMob: "top",
        },
        {
          title: "Troca de itens",
          description:
            "Ganhou cristais ao bater suas metas? Troque por itens exclusivos da coleção do Afinando!",
          target: ".store",
          progress: "3/7",
          image: tourIconStore,
          placementDesk: "right",
          placementMob: "top",
        },
        {
          title: "Veja seu progresso",
          description:
            "Aqui você poderá acompanhar as pontuações e estatísticas de todas as jogadas feitas por você ou seus convidados",
          target: ".progress",
          progress: "4/7",
          image: tourIconThree,
          placementDesk: "right",
          placementMob: "top",
        },
        {
          title: "Planos do Afinando",
          description: "Confira os planos e pacotes adicionais da plataforma!",
          target: ".buy",
          progress: "5/7",
          image: tourIconFour,
          placementDesk: "right",
          placementMob: "top",
        },
        {
          title: "Trocar de perfil",
          description:
            "Usa o Afinando Profissionalmente? Aqui você pode acessar, jogar e acompanhar o progresso dos usuários cadastrados por você!",
          target: ".changeUser",
          progress: "6/7",
          image: tourIconFive,
          placementDesk: "bottom",
          placementMob: "top",
        },
  /*       {
          title: "Seu plano atual",
          description:
            "Confira qual é o seu plano atual e fique atento à data de renovação ou vencimento.",
          target: ".plans",
          progress: "7/8",
          image: tourIconSix,
          placementDesk: "bottom",
          placementMob: "top",
        }, */
        {
          title: "Menu de opções",
          description:
            "Convide usuários, resgate código de convite ou gerencie seus usuários por aqui",
          target: ".menu",
          progress: "7/7",
          image: tourIconSeven,
          placementDesk: "bottom",
          placementMob: "top",
        },
      ]);
    }
  }, [session]);

  useEffect(() => {
    if (session && stepsFlow) {
      setSteps(
        stepsFlow.map((step) => ({
          content: (
            <div>
              <div className={classes.Title}>{step.title}</div>
              <br />
              <div className={classes.Description}>{step.description}</div>
            </div>
          ),
          disableBeacon: true,
          scrollbars: true,
          disableOverlayClose: true,
          hideCloseButton: true,
          hideBackButton: true,
          hideFooter: false,
          placement:
            widthButton > 1200 && heightButton > 650
              ? step.placementDesk
              : widthButton > 1200 && heightButton < 650
              ? step.placementMob
              : widthButton < 1200
              ? step.placementMob
              : null,
          spotlightClicks: false,
          styles: {
            options: {
              zIndex: 10000,
            },
          },
          target: step.target,
          title: (
            <div className={classes.CardTop}>
              <div className={classes.Progress}>{step.progress}</div>
              <img className={classes.Image} src={step.image} alt="" />
            </div>
          ),
        }))
      );
    }
  }, [stepsFlow, widthButton]);

  return (
    <>
      <ModalOnboardingStart
        setRun={setRun}
        openModalStart={openModalStart}
        setOpenModalStart={setOpenModalStart}
      />
      <ModalOnboardingFinish
        setRun={setRun}
        openModalFinish={openModalFinish}
        setOpenModalFinish={setOpenModalFinish}
      />
      <ReactJoyride
        steps={steps}
        run={run}
        continuous
        scrollToFirstStep
        // showProgress
        showSkipButton
        callback={handleJoyrideCallback}
        locale={{
          last: "Finalizar",
          skip: "fechar",
          next: "continuar",
          back: "Voltar",
        }}
        styles={{
          options: {
            width: 357,
            zIndex: 10000,
            backgroundColor: "#fff",
            arrowColor: "#fff",
          },
          tooltip: {
            borderRadius: 7,
            boxSizing: "border-box",
            fontSize: 16,
            maxWidth: "100%",
            padding: 0,
            position: "relative",
          },
          buttonNext: {
            backgroundColor: "#ffca55",
            borderRadius: "9.277px",
            color: "#662d91",
            width: "132.203px",
            height: "37.11px",
          },
          buttonSkip: {
            color: "#662d91",
            padding: 0,
          },
          tooltipTitle: {
            backgroundColor: "#F1ECF4",
            color: "#662d91",
            height: "63.782px",
            borderRadius: "6.982px 6.982px 0px 0px",
          },
          tooltipFooter: {
            alignItems: "center",
            display: "flex",
            justifyContent: "flex-end",
            paddingBottom: 25,
            paddingLeft: 30,
            paddingRight: 25,
            paddingTop: 5,
            marginTop: 5,
          },
          tooltipContainer: {
            textAlign: "left",
            padding: 0,
          },
          tooltipContent: {
            padding: "25px 30px 5px",
          },
        }}
      />
    </>
  );
};
export default TooltipContainer;
